export default "__VITE_ASSET__45fd69ea__";